import React from 'react';
import {
  Input, Card, Table, Button, Breadcrumb,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { PlusOutlined } from '@ant-design/icons';

import withAuth from '@common/hocs/withAuth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import MainLayout from '@common/layouts/MainLayout';

import useGateway from './useGateway';
import styles from './Gateway.module.less';

function Gateway() {

  const { t } = useTranslation();
  const {
    loading,
    pagination,
    columns,
    gateway,
    arrayFilter,
    setValueFilter,
    // onChangeSearch,
    handleTableChange,
    createGateway,
    isCreate,
  } = useGateway();

  return (
    <MainLayout applyWidthLimit>
      <div className={styles.wrapper}>
        <Breadcrumb className={styles.date_wrapper}>
          <Breadcrumb.Item className={styles.breadcrumb}>{t('menu_items.main.gateway')}</Breadcrumb.Item>
        </Breadcrumb>
        <div className={styles.rowHeader}>
          <Input
            placeholder={t('common.find_gateway')}
            className={styles.search}
            onChange={(e) => setValueFilter(e.target.value)}
            // onChange={onChangeSearch}
            suffix={<FontAwesomeIcon icon={faSearch} />}
            allowClear
          />

          {
            isCreate &&
            <div className={styles.button}>
              {`• ${gateway.length} ${t('views.create_gateway.conectedGateway')}`}
              <Button type="primary" onClick={createGateway} icon={<PlusOutlined />}>
                {t('views.create_gateway.new_gateway')}
              </Button>
            </div> 
          } 
        </div>

        <Card>
          <Table
            // scroll={{ x: 1210 }}
            className={styles.table}
            loading={loading}
            columns={columns}
            dataSource={arrayFilter}
            pagination={pagination}
            onChange={handleTableChange}
            rowKey={(record) => record.id}
          />
        </Card>
      </div>
    </MainLayout>
  );

}

export default withAuth(Gateway);
